import React from 'react'
import './style.less'
import { TimerText } from '../TimerText'

export type WaitCallProps = {
  phone: string
  waitPhone: string
  expireAt?: string | Date | number
  onChangePhone?: () => any
  onTimeout?: () => any
}

const formatPhone = (phone: string) => {
  if (!phone) {
    return ''
  }
  phone = phone.replace(/[^\d]+/g, '')
  const value = phone.length > 10 ? phone.slice(-10) : phone
  return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 8)}-${value.slice(8)}`
}

export const WaitCall = (props: WaitCallProps) => {
  const text1 = <span>{'Для подтверждения вашего номера телефона необходимо совершить исходящий звонок на указанный номер.'}</span>
  const timer = <TimerText expireAt={props.expireAt} onTimeout={props.onTimeout} />
  const textTime = <span>{'Срок действия номера телефона: '}{timer}</span>

  const text3 = <span className='extra-text'>{'Звонок по России бесплатный'}</span>
  const changeJsx = (
    <a
      href="#"
      onClick={(e) => {
        e.preventDefault()
        props.onChangePhone?.()
      }}
    >
      {'Назад'}
    </a>
  )
  const waitPhone = `8 ${formatPhone(props.waitPhone)}`
  const phone = `+7 ${formatPhone(props.phone)}`
  const waitPhoneJsx = (
    <div className="wait-phone-container">
      <strong>{text3}</strong>
      <div className="wait-phone selected">
        <span>{waitPhone}</span>
      </div>
    </div>
  )
  const descriptionJsx = (
    <p className="description wait-call">
      {text1}
      <br />
      <div className='timer'>{textTime}</div>
      {waitPhoneJsx}
      <br />
      {changeJsx}
    </p>
  )
  return (
    <>
      {descriptionJsx}
    </>
  )
}
